// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3msvW","top":"styles_top__1reQ9"};